export default __webpack_public_path__ + "static/media/questioniocn1.3e4774e1.svg";